export const SITE_URL = 'https://onekyc.io';
export const DOCS_URL = 'https://finext.gitbook.io/one-kyc';
export const CONTACT_EMAIL = 'info@onekyc.io';

export const LEGAL_DOCS_LAST_MODIFIED = '2026-08-14';
export const HELP_LAST_MODIFIED = '2026-06-26';
export const LEGAL_DOCS = [
	{ label: 'Privacy Policy', href: '/legal/privacy-policy' },
	{ label: 'User Agreement', href: '/legal/user-agreement' },
	{ label: 'License Offer', href: '/legal/license-offer' },
] as const;

export const LOGIN_URL = 'https://console.onekyc.io/login';

// Reused by Sub-project C (i18n). `dir` drives RTL for Arabic.
export const LOCALES = [
	{ code: 'en', name: 'English', dir: 'ltr' },
	{ code: 'ru', name: 'Русский', dir: 'ltr' },
	{ code: 'zh', name: '中文', dir: 'ltr' },
	{ code: 'es', name: 'Español', dir: 'ltr' },
	{ code: 'de', name: 'Deutsch', dir: 'ltr' },
	{ code: 'ar', name: 'العربية', dir: 'rtl' },
	{ code: 'fr', name: 'Français', dir: 'ltr' },
] as const;
export const DEFAULT_LOCALE = 'en';
export type LocaleCode = (typeof LOCALES)[number]['code'];
